import { Color as t } from "three";
import * as e from "../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
const { vec3: n } = e, l = (o) => o ? 1 : -1, m = (o) => {
  const r = new t(o);
  return n(r.r, r.g, r.b).value;
};
export {
  l as transformBoolean,
  m as transformColor
};
